/**
 * Was zwischen Server und Oberfläche über eine Prüfmappe hin und her geht.
 *
 * Die Formen hier bilden ab, was der Import *vorschlägt* und was jemand
 * *entschieden* hat – bewusst getrennt. Ein Vorschlag darf sich beim erneuten
 * Abgleich ändern; eine Entscheidung nicht.
 */
import { z } from 'zod';
import { fuzzyDateSchema } from './fuzzy-date.js';
export const IMPORT_STATUSES = ['draft', 'applied', 'discarded'];
export const IMPORT_DECISIONS = ['open', 'create', 'update', 'skip'];
export const IMPORT_STATUS_LABELS = {
    draft: 'In Prüfung',
    applied: 'Übernommen',
    discarded: 'Verworfen',
};
export const IMPORT_DECISION_LABELS = {
    open: 'Offen',
    create: 'Neu anlegen',
    update: 'Abgleichen',
    skip: 'Übergehen',
};
export const CONFLICT_KINDS = ['same', 'fill', 'refine', 'conflict'];
export const CONFLICT_KIND_LABELS = {
    same: 'Gleich',
    fill: 'Ergänzung',
    refine: 'Genauer',
    conflict: 'Widerspruch',
};
// ── Eingaben ───────────────────────────────────────────────────────────────
const fieldChoiceSchema = z.object({
    mode: z.enum(['take', 'keep', 'custom']),
    value: z.unknown().optional(),
});
export const importDecisionPatchSchema = z.object({
    decision: z.enum(IMPORT_DECISIONS).optional(),
    /** Eine andere Person als die vorgeschlagene zuordnen – oder die Zuordnung lösen. */
    matchPersonId: z.string().uuid().nullable().optional(),
    matchPlaceId: z.string().uuid().nullable().optional(),
    fieldChoices: z.record(fieldChoiceSchema).optional(),
});
/** Für „alle Ergänzungen übernehmen“ und ähnliche Sammelbefehle. */
export const importBulkSchema = z.object({
    scope: z.enum(['persons', 'edges', 'places']),
    action: z.enum([
        'accept-suggestions',
        'skip-open',
        'take-fills',
        'reset',
    ]),
});
export const importApplySchema = z.object({
    /** Neu angelegte Personen als „unter Vorbehalt“ kennzeichnen. */
    markUnverified: z.boolean().default(false),
    /** Nicht übernommene Angaben (Taufe, Register…) als Notiz an die Person hängen. */
    keepExtrasAsNotes: z.boolean().default(false),
    /** Die Datei als Quelle anlegen und mit allem Berührten verknüpfen. */
    createSource: z.boolean().default(true),
});
export { fuzzyDateSchema };
//# sourceMappingURL=import.js.map